// @flow
import ButtonLink from '@liveauctioneers/caterwaul-components/lib/ButtonLink/ButtonLink';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import styles from './SuspendedBidderBanner.module.scss';

type Props = {||};

const SuspendedBidderBanner = () => {
    return (
        <div className={styles.banner}>
            <div className={styles['banner-inner']}>
                <div className={styles.text}>
                    <FormattedMessage id="suspendedBidderBanner.text" />
                </div>
                <ButtonLink
                    className={styles.submit}
                    external
                    primary
                    target="_blank"
                    url="https://help.liveauctioneers.com/article/146-how-do-i-restore-my-suspended-account"
                >
                    <FormattedMessage id="suspendedBidderBanner.button" />
                </ButtonLink>
            </div>
        </div>
    );
};

export default React.memo<Props>(SuspendedBidderBanner);
